import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!-- @glint-nocheck --}}\n{{!-- template-lint-disable no-invalid-interactive --}}\n<li class=\"nav-item\" ...attributes {{on \"click\" this.handleClick}}>\n  {{yield}}\n</li>\n", {
  moduleName: "ember-bootstrap/components/bs-nav/item.hbs"
});